import {
  GlossariesApi,
  GlossariesDeleteGlossaryFileRequest,
  GlossariesDownloadGlossaryFileGetRequest,
  GlossariesUpdateGlossaryMetadataPostRequest,
  GlossariesUpsertGlossaryPostRequest,
  GlossaryFileSupportResponse,
  InitOverrideFunction,
} from "../../../@api";

export class GlossariesApiService
  implements Omit<GlossariesApi, `${string}Raw` | "withMiddleware" | "withPreMiddleware" | "withPostMiddleware">
{
  constructor(private readonly api: GlossariesApi) {}

  public glossariesUpsertGlossaryPost(
    requestParameters?: GlossariesUpsertGlossaryPostRequest,
    initOverrides?: RequestInit | InitOverrideFunction,
  ): Promise<string> {
    return this.api.glossariesUpsertGlossaryPost(requestParameters, initOverrides);
  }

  public glossariesUpdateGlossaryMetadataPost(
    requestParameters: GlossariesUpdateGlossaryMetadataPostRequest,
    initOverrides?: RequestInit | InitOverrideFunction,
  ): Promise<void> {
    return this.api.glossariesUpdateGlossaryMetadataPost(requestParameters, initOverrides);
  }

  public glossariesDeleteGlossaryFile(
    requestParameters: GlossariesDeleteGlossaryFileRequest,
    initOverrides?: RequestInit | InitOverrideFunction,
  ): Promise<string> {
    return this.api.glossariesDeleteGlossaryFile(requestParameters, initOverrides);
  }

  public glossariesGetGlossaryFileSupport(
    initOverrides?: RequestInit | InitOverrideFunction,
  ): Promise<GlossaryFileSupportResponse> {
    return this.api.glossariesGetGlossaryFileSupport(initOverrides);
  }

  public glossariesDownloadGlossaryFileGet(
    requestParameters: GlossariesDownloadGlossaryFileGetRequest,
    initOverrides?: RequestInit | InitOverrideFunction,
  ): Promise<Blob> {
    return this.api.glossariesDownloadGlossaryFileGet(requestParameters, initOverrides);
  }
}
